<!--
 * @Author: your name
 * @Date: 2021-08-05 16:52:04
 * @LastEditTime: 2022-01-17 17:23:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Basic\src\client\pages\CouponList.vue
-->
<template>
  <div style="position:relative;z-index:2;">
    <div class="list-empty" v-if="!coupon.list.length && isRequested">
      <img src="common/images/empty.png" />
      <p>当前没有任何记录哦～</p>
    </div>
    <div v-else>
      <div class="record-list" :finished="coupon.finished" finished-text="没有更多了">
        <div class="record-item" v-for="(item, index) in coupon.list" :key="index">
          <!-- <span class="record-sn">{{item.datas.activityName}}</span> -->
          <div class="record-content">
            <h3 class="record-value">{{ item.awardName }}</h3>
            <span class="record-datetime">{{ item.createTime }} 兑换</span>
          </div>
          <div class="record-money">
            ￥<strong>{{ item.awardMoney }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityRecord',
  data() {
    return {
      coupon: {
        //list: MockListRequest(10),
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        pageNum: 0,
      },
      isRequested: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    activity() {
      return this.$store.getters.activity
    },
    checkin() {
      return this.$store.getters.checkin
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch('onUserLogSend', {
      pageName: '兑奖记录页',
      behavior: { visist: '兑奖记录页' },
    })
  },
  watch: {
    user: {
      handler: function(n, o) {
        this.activity && this.activity.activityId && this.user && this.onCouponLoad()
      },
      immediate: true,
    },
    activity: {
      handler: function(n, o) {
        this.activity && this.activity.activityId && this.user && this.onCouponLoad()
      },
      immediate: true,
    },
  },
  methods: {
    onCouponLoad() {
      let coupon = this.coupon

      if (coupon.finished) return

      if (this.user) {
        console.log(1111111)
        coupon.finished = true
        this.$api.activity
          .record(
            {
              activityId: this.activity.activityId,
              openId: this.user.openId,
              pageNum: ++coupon.pageNum,
              pageSize: 100,
            },
            (bag) => {
              /* if (coupon.list.length >= bag.total && bag.data < 10)
								  {
									  coupon.finished = true;
								  } */

              this.isRequested = true
              coupon.loading = false
              console.log(222222)
            }
          )
          .then((response) => {
            console.log(33333)
            if (coupon.refreshing) {
              coupon.list = []
              coupon.refreshing = false
            }

            coupon.list.splice(coupon.list.length, 0, ...response)
            coupon.loading = false
            console.log(coupon.list)
          })
          .catch((error) => {
            console.log(error)
            this.isRequested = true
            coupon.loading = false
          })
          .then((response) => {
            console.log(5555)
          })
      }
    },
    onCouponRefresh() {
      this.coupon.pageNum = 0
      this.coupon.finished = false
      this.coupon.loading = true

      //this.onCouponLoad();
    },
  },
}
</script>
